module.exports = __webpack_public_path__ + "img/b5.7fb778c5.png";